import React from 'react';

export const useImagesArray = ({ frames, placeholderUrl }) => {
  const [imagesArray, setImagesArray] = React.useState(() => []);
  React.useEffect(() => {
    framesToImagesArray([...frames].fill(placeholderUrl)).then(setImagesArray);
    framesToImagesArray(frames).then(setImagesArray);
  }, [frames.toString(), placeholderUrl]);
  return imagesArray;
};

const loadImage = (src) =>
  new Promise((resolve, _reject) => {
    const image = new Image();

    image.src = src;
    image.onload = () => resolve(image);
  });

const framesToImagesArray = (frames) => {
  const imagesPromises = frames.map((src) => loadImage(src));
  return Promise.all(imagesPromises);
};
